import axios from "axios";
import { useState, useEffect } from "react";

const UseCompanyInfo = () => {
  const [loading, setLoading] = useState(false);
  const [companyInfo, setCompanyInfo] = useState([]);

  const rupali_api_url = process.env.REACT_APP_RUPALI_API_HOST;

  const url = `${rupali_api_url}/Api/WebSite/CompanyInfo`;

  useEffect(() => {
    axios.get(url).then((res) => {
      setCompanyInfo(res.data.data[0]);
      setLoading(true);
    });
  }, []);

  return [companyInfo, setCompanyInfo, loading];
};

export default UseCompanyInfo;
